// generated by the plop

import { TemplateFormat } from 'shared';
import { PROGRESS_STATUSES } from 'symbols';

export interface TemplateFormatStateModel {
  formatList: TemplateFormat[];
  loadFormatsStatus: PROGRESS_STATUSES;
}

export const TEMPLATE_FORMAT_STATE_DEFAULT: TemplateFormatStateModel = {
  formatList: [],
  loadFormatsStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};
